import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
     providedIn: 'root',
})

export class LogFeedService implements OnDestroy {

     private logActivityApi = this.endpoint.analyticsUrl;

     private unsubscribe = new Subject<any>();

     orgID: any;

     constructor(
          private endpoint: Endpoints,
          private http: HttpClient,
          store: Store<AppState>
     ) {
          store.select("userInfo").subscribe((info) => {
               this.orgID = info.organization.id;
          });
     }

     /**
      * Converts date strings for Java service to timestamp.
      * @param date The date string to be converted
      */
     convertDateToTimestamp(date) {
          let [dateString, timeString] = date.split(' ');
          let [day, month, year] = dateString.split('/');
          return Date.parse(`${month}/${day}/${year} ${timeString}`);
     }

     logFeeds(id, type, pageNo) {
          return this.http.get(`${this.logActivityApi}/getActivities/${id}/${type}/${this.orgID}?page=${pageNo}`)
               .pipe(takeUntil(this.unsubscribe))
               .pipe(map((logs: any) => {
                    return logs.map(log => ({
                         ...log,
                         date: this.convertDateToTimestamp(log.dateLogged),
                         itemType: 'log',
                    }));
               }))
     }

     ngOnDestroy() {
          this.unsubscribe.next();
          this.unsubscribe.complete();
     }

}